import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [

  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialNo',
    fieldName: '物料编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '库存',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'used',
    fieldName: '已占用',
    width: 80
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'actual',
  //   fieldName: '实际采购',
  //   width: 80
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialClass',
    fieldName: '物料类别'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialUnit',
    fieldName: '物料单位',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialBrand',
    fieldName: '品牌',
    width: 120
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialName',
    fieldName: '名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialModel',
    fieldName: '型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialCode',
    fieldName: '代码'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialParameter',
    fieldName: '参数'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialDevice',
    fieldName: '使用设备'
  },

  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'createUser',
  //   fieldName: '创建人'
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'status',
  //   fieldName: '状态'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'location',
    fieldName: '位置',
    convert: context => {
      const { rowData } = context
      return rowData.location?.location
    }
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'businessNo',
  //   fieldName: '业务编号'
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'marketCost',
  //   fieldName: '市场成本',
  //   textAlign: 'right',
  //   isMoney: true,
  //   width: 120
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'outCost',
  //   fieldName: '外包成本',
  //   textAlign: 'right',
  //   isMoney: true,
  //   width: 120
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'max',
  //   fieldName: '最高价'
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'min',
  //   fieldName: '最低价'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialMark',
    fieldName: '备注'
  }
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'reject',
  //   fieldName: '退回理由'
  // }
]
